import { cn } from "@/lib/utils/cn";
import type { ReactNode } from "react";
export function TopStat({
  label,
  value,
  detail,
  valueClassName,
  className,
}: {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  valueClassName?: string;
  className?: string;
}) {
  return (
    <div
      className={cn("min-w-0 border-r px-4 py-2.5 last:border-r-0", className)}
    >
      <p className="text-muted-foreground text-[10px] font-semibold">{label}</p>
      <div
        className={cn(
          "mt-1 text-sm leading-tight font-semibold",
          valueClassName,
        )}
      >
        {value}
      </div>
      {detail ? (
        <div className="text-muted-foreground mt-1 text-xs">{detail}</div>
      ) : null}
    </div>
  );
}
